// Auto-generated file. Do not edit.
import { Initializer } from "modules/Initializer";
import { AccordionBlock } from "blocks/AccordionBlock/AccordionBlock";
import { BundlingBlock } from "blocks/BundlingBlock/BundlingBlock";
import { CarouselBlock } from "blocks/CarouselBlock/CarouselBlock";
import { CaseStudyBlock } from "blocks/CaseStudyBlock/CaseStudyBlock";
import { FactsBlock } from "blocks/FactsBlock/FactsBlock";
import { FormBlock } from "blocks/FormBlock/FormBlock";
import { Breadcrumbs } from "components/Breadcrumbs/Breadcrumbs";
import { CountrySelector } from "components/CountrySelector/CountrySelector";
import { FilterGroup } from "components/FilterGroup/FilterGroup";
import { Select } from "components/Select/Select";
import { BundlePage } from "pages/BundlePage/BundlePage";
import { EventPage } from "pages/EventPage/EventPage";
import { EventsListingPage } from "pages/EventsListingPage/EventsListingPage";
import { JobListingsPage } from "pages/JobListingsPage/JobListingsPage";
import { PartnersPage } from "pages/PartnersPage/PartnersPage";
import { SubcategoryListingsPage } from "pages/SubcategoryListingsPage/SubcategoryListingsPage";
import { TrainingListingPage } from "pages/TrainingListingPage/TrainingListingPage";
import { TrainingPage } from "pages/TrainingPage/TrainingPage";

Initializer.register([
  AccordionBlock, BundlingBlock, CarouselBlock, CaseStudyBlock, FactsBlock, FormBlock, Breadcrumbs, CountrySelector, FilterGroup, Select, BundlePage, EventPage, EventsListingPage, JobListingsPage, PartnersPage, SubcategoryListingsPage, TrainingListingPage, TrainingPage
]);
